import React from 'react';
import DetailInlineGroup from '../../detail/components/groups/DetailInlineGroup';
import StaticField from '../../staticField/components/StaticField';
import { useTranslation } from 'react-i18next';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
export var HistoryGroupField = function (_a) {
    var changedBy = _a.changedBy, changedDate = _a.changedDate, createdBy = _a.createdBy, createdDate = _a.createdDate, id = _a.id, VersionBrowserButton = _a.VersionBrowserButton, version = _a.version;
    var _b = React.useState(false), expanded = _b[0], setExpanded = _b[1];
    var t = useTranslation().t;
    var handleExpandClick = function () {
        setExpanded(!expanded);
    };
    return (React.createElement("div", { className: "historyGroupField" },
        React.createElement("div", { className: 'historyGroupField__header' },
            React.createElement("div", { className: "historyGroupField__expandIcon" },
                React.createElement(AccurityIconButton, { onClick: handleExpandClick, iconName: expanded ? 'mui:ExpandLess' : 'mui:ExpandMore', "aria-expanded": expanded })),
            React.createElement(DetailInlineGroup, null,
                React.createElement(StaticField, { name: 'lastChanged', label: t('fieldLabel.changedDate'), format: 'DATE', value: changedDate }),
                React.createElement(StaticField, { name: 'changedBy', className: 'historyGroupField__changedBy', label: t('fieldLabel.changedBy'), value: changedBy.name, format: 'TRUNCATED' }))),
        expanded && React.createElement("div", { className: 'historyGroupField__body' },
            React.createElement(DetailInlineGroup, null,
                React.createElement(StaticField, { name: 'created', label: t('fieldLabel.createdDate'), format: 'DATE', value: createdDate }),
                React.createElement(StaticField, { name: 'createdBy', label: t('fieldLabel.createdBy'), value: createdBy.name, format: 'TRUNCATED' })),
            React.createElement(DetailInlineGroup, null,
                React.createElement(StaticField, { name: 'id', label: t('fieldLabel.id'), value: id }),
                React.createElement(StaticField, { name: 'version', label: t('fieldLabel.version'), value: version })),
            VersionBrowserButton)));
};
export default HistoryGroupField;
//# sourceMappingURL=HistoryGroupField.js.map